import React from "react";
import { Button } from "app/src/elements/buttons";
import { filterButton } from "./FilterStyles";
import * as Colors from "../../styles/colors";

const buttonColor = {
  backgroundColor: Colors.elRed,
  borderColor: Colors.elRed,
};

export const ResetSettings = (props) => {
  const { clearParams } = props;
  return (
    <Button
      onPress={() => clearParams ?
        window.location = '/wholesaleFlex/availability' :
        window.location.reload()
      }
      label='Reset'
      style={Object.assign({}, filterButton, buttonColor)}
    />
  );
};
